export const getStatusColor = (status: string) => {
  switch (status) {
  case 'In progress':
    return 'volcano'
  case 'Waiting for approval':
    return 'blue'
  case 'Ready to use':
    return 'green'
  default:
    return 'default'
  }
} 